import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedFromPublishedView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  template: JST["backbone/templates/monitoring/filters/from_published/applied_from_published_filter"]

  removeFilter: (value) ->
    @searchQuery.resetField('fb_parent_post_is_published')

  getFilterValue: ->
    @searchQuery.get('fb_parent_post_is_published')